import Header from '../layouts/header';
import Slideout from '../modules/slideout';
import SlideNav from '../components/slide-nav';
import MorphNav from '../components/morph-nav';
import Salescounter from '../modules/salescounter';
import Slider from '../modules/slider';
import ProductFeed from '../modules/productfeed';
import '../lib/smoothscroll';
import '../lib/multistepform';


export default {
    init() {
        Header.init();
        Slideout.init();
        SlideNav.init();
        MorphNav.init();
        Salescounter.init();
        Slider.init();
        ProductFeed.init();
        $('.collapse').collapse();
        $('[data-toggle="tooltip"]').tooltip();
    },
    finalize() {

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js